// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateUruguayanPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!/^\d{1,20}$/.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}
